import { useAuth } from "../../components/context/AuthContext";
import { CopyTextField } from "../../components/elements/Elements";
import { API_WALLETS } from "../../constants/apis";
import {
  formatDateTime,
  formatWalletNumber,
  numberFormat,
  returnKeys,
} from "../../utils/helpers";
import useGet from "../common/useGet";

export const useWallet = () => {
  const { user, updateUser } = useAuth();
  const { loadData, loading } = useGet();
  const wallet = user?.wallet;
  const { id: walletId, balance = "0", currency = "UGX" } = wallet || {};

  const getWalletBalance = (onSuccess?: (wallet?: any) => void) => {
    if (walletId) {
      loadData({
        api: API_WALLETS,
        id: walletId,
        onSuccess: (wallet: any) => {
          // SAVE WALLET TO USER
          updateUser({ ...user, wallet });
          if (onSuccess) onSuccess(wallet);
        },
      });
    }
  };

  const viewData = () => {
    const { wallet_number, created_at, balance } = wallet || {};

    return {
      ...returnKeys(wallet, [
        "wallet_number",
        "currency",
        "balance",
        "created_at",
      ]),
      wallet_number: (
        <div className="monospace">
          <CopyTextField>{formatWalletNumber(wallet_number)}</CopyTextField>
        </div>
      ),
      balance: numberFormat(balance),
      created_at: formatDateTime(created_at),
    };
  };

  return { getWalletBalance, balance, loading, walletId, currency, viewData };
};
